module.exports = __webpack_public_path__ + "static/img/p1.b10a60d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p1.jpg
// module id = 141
// module chunks = 358